import { get, post, put, remove as httpDelete } from "../Services/http";
import { catchError } from "./Error.action";
import { showModal } from "./Modal.action";
export const HTTP_ERROR = "HTTP_ERROR";
export const SAVED_CART_LOAD_ERROR = "SAVED_CART_LOAD_ERROR";
export const SAVED_CART_LIST_RECEIVE = "SAVED_CART_RECEIVE";
import { translate } from "../Services/translation";
import { receive } from "./Cart.action";
const apiBaseUrl = "/api/savedcart";

export const addToCart =
  (nodeIdToShowNotification = null, cartId) =>
  (dispatch) => {
    return post("/api/savedcart/addtocart", cartId)
      .then((response) => response.json())
      .then((cart) => {
        dispatch(showModal(translate("savedcard.success"), translate("savedcard.close")));
        dispatch(receive({ ...cart }));
      })
      .catch((ex) => dispatch(showModal(translate("savedcard.error"), translate("savedcard.close"))));
  };

  export const addProductToCart =
  (orderId, rowSystemId) =>
  (dispatch) => {
    return post("/api/savedcart/product/addtocart", { orderId, rowSystemId })
      .then((response) => response.json())
      .then((cart) => {
        dispatch(showModal(translate("savedcard.success"), translate("savedcard.close")));
        dispatch(receive({ ...cart }));
      })
      .catch((ex) => dispatch(showModal(translate("savedcard.error"), translate("savedcard.close"))));
  };


export const deleteSavedCart = (cartId) => (dispatch) => {
  return httpDelete(apiBaseUrl + "/delete", cartId)
    .then((response) => response.json())
    .catch((ex) =>
      dispatch(
        catchError(ex, (error) => {
          return loadError(error);
        })
      )
    );
};

export const updateSavedCart = (cart, selectedUserId) => (dispatch) => {
  const request = cart;
  dispatch(hideShowButton());
  return put(apiBaseUrl + "/update", request)
    .then((response) => dispatch(getUserCarts(selectedUserId)))
    .catch((ex) =>
      dispatch(
        catchError(ex, (error) => {
          return loadError(error);
        })
      )
    );
};

export const getUserCarts = (userId) => (dispatch) => {
  dispatch(clearreceiveCarts());
  dispatch(hideShowButton());
  dispatch(setUserId(userId));
  return get(apiBaseUrl + "/user/" + userId)
    .then((response) => response.json())
    .then((data) => dispatch(receiveCarts(data)))
    .catch((ex) =>
      dispatch(
        catchError(ex, (error) => {
          return loadError(error);
        })
      )
    );
};
export const getSelectedCart = (orderId) => (dispatch) => {
  if (orderId) {
    dispatch(clearSelectedCart());
    return get(apiBaseUrl + "/order/" + orderId)
      .then((response) => response.json())
      .then((data) => dispatch(receiveSelectedCart(data, orderId)))
      .catch((ex) =>
        dispatch(
          catchError(ex, (error) => {
            return loadError(error);
          })
        )
      );
  }
};

export const removeSavedCartOrderRow = (orderId, rowSystemId) => (dispatch) => {
  if (orderId) {
    return httpDelete(apiBaseUrl + "/orderRow/delete", { orderId, rowSystemId })
      .then((response) => response.json())
      .then(() => dispatch(getSelectedCart(orderId)))
      .catch((ex) =>
        dispatch(
          catchError(ex, (error) => {
            return loadError(error);
          })
        )
      );
  }
};

export const updateSavedCartName = (orderId, name) => (dispatch) => {
  return put(apiBaseUrl + "/titleupdate", { orderId, name })
    .catch((ex) =>
      dispatch(
        catchError(ex, (error) => {
          return loadError(error);
        })
      )
    );
};

export const setUpdatedCart = (cart) => (dispatch) => {
  return dispatch(updatereceiveCarts(cart));
};
export const setDeleteCart = (cart) => (dispatch) => {
  dispatch(clearreceiveCarts());
  return dispatch(deletereceiveCarts(cart));
};
export const setShowButton = (status, savedCarts) => (dispatch) => {
  let arrayItem = [];
  savedCarts.map((cart, index) => {
    cart.isDelete = false;
    arrayItem.push(cart);
  });
  dispatch(showShowButton(status, arrayItem));
};

export const changeSavedCartName = (name) => (dispatch) => {
  return dispatch(changeSelectedOrderName(name));
};

export const loadError = (error) => ({
  type: SAVED_CART_LOAD_ERROR,
  payload: {
    error,
  },
});

const receiveCarts = (carts) => ({
  type: SAVED_CART_LIST_RECEIVE,
  payload: {
    savedCarts: carts,
    loadingStatus: "Completed",
  },
});
const updatereceiveCarts = (carts) => ({
  type: SAVED_CART_LIST_RECEIVE,
  payload: {
    savedCarts: carts,
    showUpdateButton: true,
    loadingStatus: "Completed",
  },
});
const deletereceiveCarts = (carts) => ({
  type: SAVED_CART_LIST_RECEIVE,
  payload: {
    savedCarts: carts,
    loadingStatus: "Completed",
  },
});

const clearreceiveCarts = () => ({
  type: SAVED_CART_LIST_RECEIVE,
  payload: {
    savedCarts: [],
    loadingStatus: "Loading",
  },
});
const hideShowButton = () => ({
  type: SAVED_CART_LIST_RECEIVE,
  payload: {
    showUpdateButton: false,
  },
});
const setUserId = (value) => ({
  type: SAVED_CART_LIST_RECEIVE,
  payload: {
    selectedUserId: value,
  },
});
const showShowButton = (status, savedCarts) => ({
  type: SAVED_CART_LIST_RECEIVE,
  payload: {
    showUpdateButton: status,
    savedCarts: savedCarts,
  },
});

export const receiveSelectedCart = (carts, orderId) => ({
  type: SAVED_CART_LIST_RECEIVE,
  payload: {
    selectedCart: carts,
    cartId: orderId,
    loadingStatus: "Completed",
  },
});

export const clearSelectedCart = () => ({
  type: SAVED_CART_LIST_RECEIVE,
  payload: {
    selectedCart: {},
    cartId: null,
    loadingStatus: "Loading",
  },
});

const changeSelectedOrderName = (name) => ({
  type: SAVED_CART_LIST_RECEIVE,
  payload: {
    selectedOrderName: name,
  },
});
